import { AddShoppingCart, ContentCopy, Shop } from '@mui/icons-material';
import { Box, Button, IconButton, InputAdornment, List, ListItem, Modal, Stack, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useAppContext } from '../../../contexts/AppContext';

function OrderButton({ generateShareUrl }) {

    const [isOrderModalOpen, setIsOrderModalOpen] = React.useState(false);
    const [shareUrl, setShareUrl] = React.useState('');

    const { showSnackbar } = useAppContext();

    const handleOrderClick = () => {
        generateShareUrl().then(url => setShareUrl(url));
        setIsOrderModalOpen(true);
    };

    const handleOrderModalClose = () => {
        setIsOrderModalOpen(false);
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(shareUrl);
        showSnackbar('Design URL copied to clipboard!', 'success');
    };

    return (
        <>
            <Button variant="outlined" color="primary" startIcon={<Shop />}
                id="reset-button"
                onClick={handleOrderClick}
            >
                Order Now
            </Button>
            <Modal
                open={isOrderModalOpen}
                onClose={handleOrderModalClose}
                aria-labelledby="order-modal-title"
                aria-describedby="order-modal-description"
            >
                <Box sx={{
                    p: 4,
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                    boxShadow: 24,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}>
                    <Typography id="order-modal-title" variant="h6" component="h2">
                        Order Process
                    </Typography>
                    <Typography id="order-modal-description" sx={{ mt: 2 }}>
                        <List dense sx={{ listStyle: "decimal", pl: 4 }}>
                            <ListItem sx={{ display: "list-item" }}>Copy the design URL below.</ListItem>
                            <ListItem sx={{ display: "list-item" }}>Click the &quot;Shop Now&quot; button to see the listing on Etsy.</ListItem>
                            <ListItem sx={{ display: "list-item" }}>Select a leather and thread color.</ListItem>
                            <ListItem sx={{ display: "list-item" }}>Enter the design URL in the personalization box, along with any other customizations.</ListItem>
                            <ListItem sx={{ display: "list-item" }}>Complete the checkout process.</ListItem>
                        </List>
                    </Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        value={shareUrl}
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleCopyClick}>
                                        <ContentCopy />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography variant='body1' sx={{ mt: 2, textAlign: 'center' }}><em>We can&apos;t wait to make your new favorite leather accessory!</em></Typography>
                    <Stack direction="row" gap={2} sx={{ mt: 2 }} justifyContent="center">
                        <Button onClick={handleOrderModalClose} variant="outlined" color="primary" sx={{ mt: 2 }}>
                            Close
                        </Button>
                        <Button href="https://kbrosleather.etsy.com/listing/1712731261/italian-leather-bifold-wallet-badalassi" target='_blank' variant="contained" color="primary" sx={{ mt: 2 }} startIcon={<AddShoppingCart />}>
                            Shop Now
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </>
    )
}

OrderButton.propTypes = {
    generateShareUrl: PropTypes.func.isRequired,
};

export default OrderButton